"use client";
/**
 * Lead-page FAQ — v6 faq-section + .faq-list accordion (same state-based
 * accordion + data-slot / aria-expanded hooks as every other redesigned FAQ).
 * Driven by the page's config `faqs`, which are ALSO emitted as FAQPage JSON-LD
 * in leadPage.tsx — so the visible FAQ and the schema stay in lockstep (AEO).
 * Styles: chapters.css.
 */
import { useState } from "react";

export interface LeadFaqItem {
    question: string;
    answer: string;
}

export default function LeadFaq({
    heading,
    items,
    idBase,
}: {
    heading: string;
    items: LeadFaqItem[];
    idBase: string;
}) {
    const [open, setOpen] = useState<number | null>(null);

    return (
        <section className="section-pad faq-section">
            <h2 className="display">{heading}</h2>
            <div className="faq-list">
                {items.map((item, i) => {
                    const isOpen = open === i;
                    return (
                        <div
                            className="faq-item"
                            data-slot="accordion-item"
                            key={item.question}
                        >
                            <button
                                type="button"
                                data-slot="accordion-trigger"
                                aria-expanded={isOpen}
                                aria-controls={`${idBase}-faq-panel-${i}`}
                                id={`${idBase}-faq-trigger-${i}`}
                                onClick={() => setOpen(isOpen ? null : i)}
                            >
                                <span className="mono">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                {item.question}
                            </button>
                            {isOpen && (
                                <div
                                    data-slot="accordion-content"
                                    id={`${idBase}-faq-panel-${i}`}
                                    role="region"
                                    aria-labelledby={`${idBase}-faq-trigger-${i}`}
                                >
                                    <p>{item.answer}</p>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
